import axios from "axios";

const InitialState = {
  counterPrograms: null,
  counterExpertise: null
};

const MANAGE_OOP_RESOURCES_OP_MOD_INDEX_TYPE = "MANAGE_OOP_RESOURCES_OP_MOD_INDEX_TYPE";

function counterProgramsGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-programs-programs", {
    headers: {'Accept': 'application/json'},
  });
}

function counterModulesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-programs-modules", {
    headers: {'Accept': 'application/json'},
  });
}

function counterExpertiseGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-programs-expertise", {
    headers: {'Accept': 'application/json'},
  });
}

function counterMasterClassesGetRequest() {
  return axios("/work/api/dashboard/counter/manage-resources-master-classes", {
    headers: {'Accept': 'application/json'},
  });
}


function counterProgramsReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_OP_MOD_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterPrograms: item
      }
    }
  }
}

function counterModulesReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_OP_MOD_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterModules: item
      }
    }
  }
}

function counterMasterClassReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_OP_MOD_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterMasterClasses: item
      }
    }
  }
}

function counterExpertiseReceive(item) {
  return {
    type: MANAGE_OOP_RESOURCES_OP_MOD_INDEX_TYPE,
    reduce: (state) => {
      return {
        ...state,
        counterExpertise: item
      }
    }
  }
}

export function counterProgramsQuery() {
  return (dispatch) => {
    return counterProgramsGetRequest()
      .then(response => {
        dispatch(counterProgramsReceive(response.data))
      }, err => {
        dispatch(counterProgramsReceive(null))
      })
  }
}

export function counterModulesQuery() {
  return (dispatch) => {
    return counterModulesGetRequest()
      .then(response => {
        dispatch(counterModulesReceive(response.data))
      }, err => {
        dispatch(counterModulesReceive(null))
      })
  }
}

export function counterMasterClassQuery() {
  return (dispatch) => {
    return counterMasterClassesGetRequest()
      .then(response => {
        dispatch(counterMasterClassReceive(response.data))
      }, err => {
        dispatch(counterMasterClassReceive(null))
      })
  }
}

export function counterExpertiseQuery() {
  return (dispatch) => {
    return counterExpertiseGetRequest()
      .then(response => {
        dispatch(counterExpertiseReceive(response.data))
      }, err => {
        dispatch(counterExpertiseReceive(null))
      })
  }
}

export function reducer(state = InitialState, action) {
  if (action.type === MANAGE_OOP_RESOURCES_OP_MOD_INDEX_TYPE) {
    return action.reduce(state)
  }
  return state;
}
